@if (withAstonLogo) {
  <div class="top-bar-logo app-logo">
    <img ngSrc="{{ assetsPath }}/assets/images/logos/logo_aston_ai.png" [width]="120" [height]="28" [alt]="'App.Name' | translate">
  </div>
}

@if (title) {
  <h1 class="tenant-title">{{ title | uppercase }}</h1>
}

<div class="user-actions">
  @if (user) {
    <h4 class="mb-0 mr-4">{{ user.fullName | fullName }}</h4>
  }
  @if (withThemeSelector) {
    <button class="btn themes-toggle d-none d-md-block" (click)="onToggleThemesPanel()">
      <i class="mr-2 far fa-palette"></i>
    </button>
  }
  <div class="user-languages d-none d-md-block">
    <div ngbDropdown placement="bottom-right" (openChange)="onToggleThemesPanel(false)">
      @if (currentLanguage$ | async; as currentLanguage) {
        <button class="btn btn-secondary" ngbDropdownToggle data-cy="DropdownToggle">
          {{ 'App.Languages.' + currentLanguage + '.short' | translate }}
        </button>
      }
      <div class="dropdown-menu" ngbDropdownMenu>
        @for (language of languages; track language) {
          <button class="dropdown-item" ngbDropdownItem (click)="onChangeLanguage(language)">
            {{ language | uppercase }}
          </button>
        }
      </div>
    </div>
  </div>

  <div data-testid="UserAccountMenu" class="user-account">
    <a (click)="logoutConfirmation()" class="btn btn-icon">
      <i class="far fa-power-off"></i>
    </a>
  </div>
</div>
